export const testData = {
    studentName: '학생_197',
    schoolName: '학교',
    schoolGrade: '1',
    issueDate: '2023-03-07',
    elapsedMinute: 64,
    correctCount: 24,
    point: 70,
    grade: 3,
    satComment:
        " 학생_197 학생의 모의평가 결과 70점으로, 수능 등급은 3등급으로 예측됩니다. 평가에 총 64분 17초 소요되어실전에서 요구되는 평가시간을 초과하였습니다. 평가 시간이 제한적인 수능에서는 지문을 읽고 문항 풀이 시간을 배분하는 능력도 아주 중요합니다. 각 지문별 나의 풀이시간과 목표시간을 비교하여 어떤 주제/갈래에 시간을 많이 할애하고 있는지 확인해보세요.\n 지문 분석 결과, 현대시 '풀잎' 지문의 정답률이 가장 높고, 현대시 '풀잎' 지문 정답률이 가장 낮습니다.\n 문항별로 살펴보면, 모든 문항 유형에 취약합니다.\n 수능 1등급을 달성하려면 다양한 제재의 잘 다듬어진 글을 읽고, 문제 풀이를 통해 글 내용을 잘 이해했는지 확인하는 체계적인 트레이닝이 필요합니다. 자신의 강점을 살리고 약점을 보완하는 체계적인 독해 트레이닝을 지속적으로 진행한다면 수능에서 좋은 결과를 얻을 수 있을 것입니다.",
    analysisResult: {
        analysis5080: 35,
        analysis5078: 20,
        analysis5079: 0,
        analysis5085: 0,
        analysis5077: 20,
        analysis5081: 20,
    },
    problemTypeResult: {
        typenegative: 16,
        typeall: 16,
        typepart: 40,
        typepositive: 13,
        typeoptionexist: 0,
        typeoptionnone: 17,
    },
    passageResultListL: [
        {
            passageSeq: 2629,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: '현대시',
            passageName: '풀잎',
            kreadScore: '',
            bookDesc: '203',
            correctRate: 12,
            solveTime: 60,
            elapsedTime: 75795,
        },
        {
            passageSeq: 2634,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: '현대시',
            passageName: '가는 길',
            kreadScore: '',
            bookDesc: '111',
            correctRate: 37,
            solveTime: 60,
            elapsedTime: 19424,
        },
        {
            passageSeq: 2642,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: '현대소설',
            passageName: '노인과 바다1',
            kreadScore: '1301',
            bookDesc: '1838',
            correctRate: 0,
            solveTime: 260,
            elapsedTime: 19902,
        },
        {
            passageSeq: 2884,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: '현대시',
            passageName: '풀잎',
            kreadScore: '',
            bookDesc: '203',
            correctRate: 100,
            solveTime: 60,
            elapsedTime: 329024,
        },
        {
            passageSeq: 2896,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: '현대시',
            passageName: '가는 길',
            kreadScore: '',
            bookDesc: '111',
            correctRate: 33,
            solveTime: 60,
            elapsedTime: 15832,
        },
        {
            passageSeq: 2903,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: '현대소설',
            passageName: '노인과 바다1',
            kreadScore: '1301',
            bookDesc: '1838',
            correctRate: 33,
            solveTime: 257,
            elapsedTime: 29533,
        },
        {
            passageSeq: 3000,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: null,
            passageName: '',
            kreadScore: '',
            bookDesc: '',
            correctRate: 50,
            solveTime: 0,
            elapsedTime: 5164,
        },
        {
            passageSeq: 3013,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: null,
            passageName: '',
            kreadScore: '',
            bookDesc: '',
            correctRate: 50,
            solveTime: 0,
            elapsedTime: 3055,
        },
        {
            passageSeq: 3015,
            areaCode: '01',
            firstNo: 0,
            lastNo: 0,
            topic: null,
            passageName: '',
            kreadScore: '',
            bookDesc: '',
            correctRate: 75,
            solveTime: 0,
            elapsedTime: 2877,
        },
    ],
    passageResultListN: [
        {
            passageSeq: 2636,
            areaCode: '02',
            firstNo: 0,
            lastNo: 0,
            topic: '인문: 논리/심리/인지/감성/언어',
            passageName: '자아 개념의 형성',
            kreadScore: '1326',
            bookDesc: '1413',
            correctRate: 12,
            solveTime: 186,
            elapsedTime: 25004,
        },
        {
            passageSeq: 2661,
            areaCode: '02',
            firstNo: 0,
            lastNo: 0,
            topic: '인문: 논리/심리/인지/감성/언어',
            passageName: '독서 치료',
            kreadScore: '1312',
            bookDesc: '1460',
            correctRate: 12,
            solveTime: 204,
            elapsedTime: 20670,
        },
        {
            passageSeq: 3132,
            areaCode: '02',
            firstNo: 0,
            lastNo: 0,
            topic: null,
            passageName: '',
            kreadScore: '',
            bookDesc: '',
            correctRate: 50,
            solveTime: 0,
            elapsedTime: 3498,
        },
        {
            passageSeq: 3134,
            areaCode: '02',
            firstNo: 0,
            lastNo: 0,
            topic: null,
            passageName: '',
            kreadScore: '',
            bookDesc: '',
            correctRate: 50,
            solveTime: 0,
            elapsedTime: 3433,
        },
        {
            passageSeq: 3296,
            areaCode: '02',
            firstNo: 0,
            lastNo: 0,
            topic: '인문: 논리/심리/인지/감성/언어',
            passageName: '자아 개념의 형성',
            kreadScore: '1301',
            bookDesc: '1328',
            correctRate: 33,
            solveTime: 186,
            elapsedTime: 15340,
        },
        {
            passageSeq: 3307,
            areaCode: '02',
            firstNo: 0,
            lastNo: 0,
            topic: '인문: 논리/심리/인지/감성/언어',
            passageName: '독서 치료',
            kreadScore: '1312',
            bookDesc: '1460',
            correctRate: 33,
            solveTime: 204,
            elapsedTime: 14768,
        },
    ],
    problemResultListL: [
        {
            answerHistorySeq: 4831,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '사실적 독해',
            learningConceptName: '내용 이해의 적절성 평가',
            correct: '③',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4832,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '추론적 독해',
            learningConceptName: '어휘의 문맥적 의미 이해',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4833,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '감상적 독해',
            learningConceptName: '수필의 수용과 감상',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4834,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '어휘',
            learningConceptName: '견해에 대한 비판',
            correct: '⑤',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4835,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '사실적 독해',
            learningConceptName: '자료를 활용한 탐구',
            correct: '③',
            answer: '⑤',
            correctYn: false,
        },
        {
            answerHistorySeq: 4836,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '추론적 독해',
            learningConceptName: '어휘의 의미와 기능',
            correct: '⑤',
            answer: '③',
            correctYn: false,
        },
        {
            answerHistorySeq: 4837,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '감상적 독해',
            learningConceptName: '수필의 수용과 감상',
            correct: '③',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4838,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '어휘',
            learningConceptName: '작품 이해의 적절성 평가',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4839,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4840,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4841,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '②',
            correctYn: true,
        },
        {
            answerHistorySeq: 4842,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4846,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '사실적 독해',
            learningConceptName: '내용 이해의 적절성 평가',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4847,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '추론적 독해',
            learningConceptName: '추가된 내용으로 인한 효과 추론',
            correct: '②',
            answer: '③',
            correctYn: false,
        },
        {
            answerHistorySeq: 4848,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '감상적 독해',
            learningConceptName: '본용언과 보조 용언의 구분',
            correct: '②',
            answer: '③',
            correctYn: false,
        },
        {
            answerHistorySeq: 4849,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '어휘',
            learningConceptName: '자료를 바탕으로 한 입장 추론',
            correct: '②',
            answer: '②',
            correctYn: true,
        },
        {
            answerHistorySeq: 4850,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '사실적 독해',
            learningConceptName: '반응의 적절성 평가',
            correct: '⑤',
            answer: '⑤',
            correctYn: true,
        },
        {
            answerHistorySeq: 4851,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '추론적 독해',
            learningConceptName: '어휘의 의미와 기능',
            correct: '②',
            answer: '④',
            correctYn: false,
        },
        {
            answerHistorySeq: 4852,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '감상적 독해',
            learningConceptName: '수필의 수용과 감상',
            correct: '③',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4853,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '어휘',
            learningConceptName: '내용 이해의 적절성 평가',
            correct: '①',
            answer: '③',
            correctYn: false,
        },
        {
            answerHistorySeq: 4854,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4855,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4856,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4857,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4891,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '사실적 독해',
            learningConceptName: '인물과 사건의 이해',
            correct: '⑤',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4892,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '추론적 독해',
            learningConceptName: '서술상의 특징',
            correct: '③',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4893,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '감상적 독해',
            learningConceptName: '독자의 수용 및 반응',
            correct: '⑤',
            answer: '③',
            correctYn: false,
        },
        {
            answerHistorySeq: 4894,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '어휘',
            learningConceptName: '문맥적 의미의 유사성 판단',
            correct: '④',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4895,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '사실적 독해',
            learningConceptName: '인물의 태도',
            correct: '③',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4896,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '추론적 독해',
            learningConceptName: '시점에 대한 이해',
            correct: '⑤',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4897,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '감상적 독해',
            learningConceptName: '감상의 적절성 평가',
            correct: '③',
            answer: '⑤',
            correctYn: false,
        },
        {
            answerHistorySeq: 4898,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '어휘',
            learningConceptName: '바꿔 쓰기에 적절한 어휘',
            correct: '④',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4899,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4900,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4901,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4902,
            problemOrd: 0,
            areaCode: '01',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
    ],
    problemResultListN: [
        {
            answerHistorySeq: 4861,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '사실적 독해',
            learningConceptName: '개괄적 정보 확인',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4862,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '추론적 독해',
            learningConceptName: '개괄적 내용 추론',
            correct: '④',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4863,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '비판적 독해',
            learningConceptName: '자료를 통한 비판의 적절성 평가',
            correct: '⑤',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4864,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '어휘',
            learningConceptName: '바꿔 쓰기에 적절한 어휘',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4865,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '사실적 독해',
            learningConceptName: '개괄적 정보 확인',
            correct: '⑤',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4866,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '추론적 독해',
            learningConceptName: '세부 정보 추론',
            correct: '⑤',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4867,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '비판적 독해',
            learningConceptName: '반응의 적절성 평가',
            correct: '③',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4868,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '어휘',
            learningConceptName: '상황에 알맞은 한자 성어',
            correct: '④',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4869,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4870,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4871,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4872,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4876,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '사실적 독해',
            learningConceptName: '개괄적 정보 확인',
            correct: '①',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4877,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '추론적 독해',
            learningConceptName: '개괄적 내용 추론',
            correct: '③',
            answer: '③',
            correctYn: true,
        },
        {
            answerHistorySeq: 4878,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '비판적 독해',
            learningConceptName: '자료 해석의 적절성 평가',
            correct: '④',
            answer: '③',
            correctYn: false,
        },
        {
            answerHistorySeq: 4879,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '어휘',
            learningConceptName: '바꿔 쓰기에 적절한 어휘',
            correct: '①',
            answer: '③',
            correctYn: false,
        },
        {
            answerHistorySeq: 4880,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '사실적 독해',
            learningConceptName: '세부 정보 추론',
            correct: '⑤',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4881,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '추론적 독해',
            learningConceptName: '내용을 바탕으로 한 상황 추론',
            correct: '③',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4882,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '비판적 독해',
            learningConceptName: '반응의 적절성 평가',
            correct: '⑤',
            answer: '②',
            correctYn: false,
        },
        {
            answerHistorySeq: 4883,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '어휘',
            learningConceptName: '문맥적 의미의 유사성 판단',
            correct: '⑤',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4884,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4885,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '②',
            answer: '①',
            correctYn: false,
        },
        {
            answerHistorySeq: 4886,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
        {
            answerHistorySeq: 4887,
            problemOrd: 0,
            areaCode: '02',
            analysisName: '',
            learningConceptName: '',
            correct: '①',
            answer: '①',
            correctYn: true,
        },
    ],
};
